const INPUT_TYPES = {
    Choice: 'typelist',
    String: 'text',
    Boolean: 'boolean',
    Integer: 'number',
    Date: 'date',
};

export default question => ({
    inputCtrlType: {
        get: () => INPUT_TYPES[question.questionType],
    },
});
